import React from "react";
import * as styles from "./hubspotForm.module.scss"
import HubspotForm from 'react-hubspot-form'

const HubspotFormComponent = ({ data }) => {

    return(
        <div className={styles.wrapper} id="contact">
            <div className="container">
                <p className={styles.htag}>{!data.title ? `Let's talk.` : data.title}</p>
                <HubspotForm 
                    portalId={data.portalId}
                    formId={data.formId}
                    // loading={<div></div>}
                />
            </div>
        </div>
    )
}

export default HubspotFormComponent